import { makeStyles } from "@material-ui/core/styles";

export const useFiltersStyles = makeStyles((theme) => ({
  dateRange: {
    color: "#999999",
    display: "flex",
    "align-items": "center",
    "justify-content": "space-between",
  },
  error: {
    "font-size": "1rem",
    margin: "-15px 0 20px 0",
  },
}));
